import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { coursesAPI} from "api/Interactions/CoursesAPI";
import { Course } from "api/Interactions/InteractionsInterfaces";
import CourseEmptyPage from "./CoursesEmptyPage";
import GenericDetailPage from "components/Interactions/GenericDetailPage";

interface CourseDetailProps {
  courseId: number;
  onClose?: () => void;
}

const CourseDetail: React.FC<CourseDetailProps> = ({ courseId, onClose }) => {
  const theme = useTheme();
  const [record, setRecord] = useState<Course | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const numberOfCourses = record?.people?.length || 0;
  const costPerCourse = 0.05;

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const data = await coursesAPI.getById(courseId);
        setRecord(data as Course);
      } catch (err) {
        console.error("Error loading course:", err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [courseId]);

  const handleUpdate = async (id: number, field: keyof Course, value: any) => {
    if (typeof id !== "number") return;
    try {
      setSaving(true);
      const updated = await coursesAPI.updateField(id, field, value);
      setRecord(updated as Course);
    } catch (err) {
      console.error(`Error updating field "${String(field)}":`, err);
    } finally {
      setSaving(false);
    }
  };

  const handleToggleFulfilled = async () => {
    if (!record) return;
    await handleUpdate(record.id, "pathways_fulfilled", !record.pathways_fulfilled);
  };

  if (loading) return null;
  if (!record) return <CourseEmptyPage />;

  return (
    <GenericDetailPage
      record={record}
      loading={loading}
      saving={saving}
      onClose={onClose}
      onUpdate={handleUpdate}
      onToggleFulfilled={handleToggleFulfilled}
      fulfilled={!!record.pathways_fulfilled}
      fulfillmentDetailsLabel="Courses"
      numberOfItems={numberOfCourses}
      costPerItem={costPerCourse}
      showSaveButton
      saveButtonColor={theme.custom.modules.interactions.primary.dark}
      fulfilledByPathwaysAvailable={false}
      registration={true}
      registrationLink={"/Conversations/Register/"+record.id}
      contentDetailFields={[
        { label: "Course Name", value: record.course_name, field: "course_name" },
        { label: "Session", value: record.session, field: "session" },
        { label: "Location", value: record.location, field: "location" },
        { label: "Start Time", value: record.start_time, field: "start_time" },
        { label: "End Time", value: record.end_time, field: "end_time" },
        { label: "Capacity", value: record.capacity, field: "capacity" },
        { label: "Registration Required", value: record.registration_required, field: "registration_required" },
        { label: "Materials Provided", value: record.materials_provided, field: "materials_provided" },
        
      ]}
    />
  );
};

export default CourseDetail;
